var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"block py-3 px-3 rounded-full border-2 flex justify-center items-center text-xs transition",class:_vm.classObject,attrs:{"to":_vm.to,"append":_vm.append}},[_c('b',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }